// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { push } from 'react-router-redux';
import styles from './changeRequestSuccessView.css';
import { MdCheck } from 'react-icons/lib/md';

import * as selectors from '../../../reducers';
import Button from "../../Button";
import PopupFooter from "../../PopupFooter";


type ChangeRequestSuccessViewPropTypes = {
  isAuthenticated: boolean,
  isAdmin: boolean,
  handleAuthenticated: boolean => void
};

class ChangeRequestSuccessView extends React.Component<ChangeRequestSuccessViewPropTypes> {
  render() {
    return (

      <div className={styles.container}>
        <h1 className={styles.text}>La solicitud de cambio ha sido procesada correctamente.</h1>
        <MdCheck className={styles.icon} size={250} />
        <Button onClick={() => {
          window.location.href = 'https://app.onthebus.io';
        }} title="Regresar a OntheBus" />
      </div>

    );
  }
}

export default connect(
  state => ({
    isAuthenticated: selectors.isAuthenticated(state),
    isAdmin: true,
  }),
  dispatch => ({
    handleAuthenticated(isAdmin) {
      if (isAdmin) {
        dispatch(push('admin/backend/events'));
      } else {
        // LOGOUT?
      }
    },
  }),
)(ChangeRequestSuccessView);



// WEBPACK FOOTER //
// ./src/scripts/components/views/ChangeRequestSuccessView/index.jsx